import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from '../../models/item.model';

/**
 * Not-found state for a record page whose id does not resolve (unknown course, learning path, library item,
 * notification, training plan or CMS page): the page heading, one sentence and a link back to the parent list.
 * Same markup as the `user-profile` not-found block. Unified Code renders the heading as the page `<h1>`; Custom
 * mode keeps the legacy `<h3>` level. `titleKey` is optional for pages that already render the heading elsewhere.
 */
@Component({
  selector: 'app-not-found-state',
  templateUrl: './not-found-state.component.html',
  styleUrls: ['./not-found-state.component.scss']
})
export class NotFoundStateComponent {
  @Input() titleKey?: string;
  @Input() messageKey!: string;
  @Input() linkKey!: string;
  @Input() link: string | unknown[] = '/home';
  @Input() queryParams?: Params;

  constructor(private identityService: IdentityService, private languageService: LanguageService) { }

  get isUnified(): boolean {
    return this.identityService.isUnifiedCode();
  }

  get isRtl(): boolean {
    return this.languageService.getCurrentLanguage() === LanguageEnum.ar;
  }
}
